import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IConfigurationService {
  apiUrl = environment.apiBaseUrl + 'Configuration';

 enableSpecialPricingDiscountFormulas: boolean;
 enableCollisionDiscounts: boolean;
 enableOeDiscount: boolean;
 enableMechSupplierAccess: boolean;
 enableQuickCalculator: boolean;
 enableDiscountOE: boolean;
 discountOeDisplayName: string;
  constructor(
    private httpClient: HttpClient) {
  }

  get(): Observable<IConfiguration> {
    return this.httpClient.get<IConfiguration>(this.apiUrl)
      .pipe(
        tap(config => {
          this.enableSpecialPricingDiscountFormulas = config.enableSpecialPricingDiscountFormulas;
          this.enableCollisionDiscounts = config.enableCollisionDiscounts;
          this.enableOeDiscount = config.enableOeDiscount;
          this.enableMechSupplierAccess = config.enableMechSupplierAccess;
          this.enableQuickCalculator = config.enableQuickCalculator;
          this.enableDiscountOE = config.enableDiscountOE;
          this.discountOeDisplayName = config.discountOeDisplayName;
        })
      );
  }
}

interface IConfiguration {
  enableSpecialPricingDiscountFormulas: boolean;
  enableCollisionDiscounts: boolean;
  enableOeDiscount: boolean;
  enableMechSupplierAccess: boolean;
  enableQuickCalculator: boolean;
  traxPartnersPendoEnabled: boolean;
  pendoApiKey: string;
  enableDiscountOE: boolean;
  discountOeDisplayName: string;
}
